export const editOverride = component => component.edit && !component.props.currentDateBeforeStartDate;

export default editOverride;
